var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6198 1.93606C12.9917 1.02131 11.0083 1.02131 9.38018 1.93606L3.34356 5.32762C1.88548 6.14682 1.88548 8.25428 3.34356 9.07348L9.38018 12.465C11.0083 13.3798 12.9917 13.3798 14.6198 12.465L20.6564 9.07348C22.1145 8.25428 22.1145 6.14682 20.6564 5.32762L14.6198 1.93606Z",
    fill: "#28303F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97517 15.337C1.89805 16.277 2.02084 18.0803 3.34356 18.8235L9.38018 22.215C11.0083 23.1298 12.9917 23.1298 14.6198 22.215L20.6564 18.8235C21.9792 18.0803 22.102 16.277 21.0248 15.337L15.3545 18.5228C13.2701 19.6939 10.7299 19.6939 8.64545 18.5228L2.97517 15.337Z",
    fill: "#28303F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81218 10.4955C1.91468 11.4674 2.0918 13.1202 3.34356 13.8235L9.38018 17.215C11.0083 18.1298 12.9917 18.1298 14.6198 17.215L20.6564 13.8235C21.9082 13.1202 22.0853 11.4674 21.1878 10.4955L15.3545 13.7728C13.2701 14.9439 10.7299 14.9439 8.64545 13.7728L2.81218 10.4955Z",
    fill: "#28303F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsActive);
export default __webpack_public_path__ + "static/media/Projects-active.26d1ecfca47620c2c3ec7003ca8fb421.svg";
export { ForwardRef as ReactComponent };